const apiKey = {
  SERVICE_ID: `service_zy4z6bz`,
  SERVICE_REQUEST_TEMPLATE_ID: `template_m0rpk2g`,
  PUBLIC_KEY: `oquE2pE1J2nVkaAih`,
};

export default apiKey;
